import { useQueryWithErrorBoundary, useSupabaseTypedClient } from 'hooks/reactQuery';

import { UserAsset } from 'types/edgeFunctions';
import { TanstackQueryName } from 'types/frontend';

interface IUseGetUserAssetsQueryParams {
  userId?: string;
  entityType?: string;
  entityId?: string;
}

export const useGetUserAssetsQuery = ({
  userId,
  entityType,
  entityId,
}: IUseGetUserAssetsQueryParams) => {
  const supabase = useSupabaseTypedClient();

  const { data, isPending } = useQueryWithErrorBoundary({
    queryKey: [TanstackQueryName.GetUserAssets, userId, entityType, entityId],
    queryFn: async (): Promise<UserAsset[]> => {
      let query = supabase
        .from('user_asset')
        .select('id, file_name, file_size_bytes, content_type, public_url, created_at')
        .eq('user_id', userId!)
        .order('created_at', { ascending: false });

      if (entityType) {
        query = query.eq('entity_type', entityType);
      }

      if (entityId) {
        query = query.eq('entity_id', entityId);
      }

      const { data, error } = await query;

      if (error) throw error;

      return (data || []).map((asset) => ({
        id: asset.id,
        fileName: asset.file_name,
        fileSizeBytes: asset.file_size_bytes,
        contentType: asset.content_type,
        publicUrl: asset.public_url,
        createdAt: asset.created_at,
      }));
    },
    enabled: Boolean(userId),
  });

  return {
    assets: data || [],
    isPending,
  };
};
